module.exports = __webpack_public_path__ + "static/media/illu_fiche-projet.e1592aa3.svg";